import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import LikeButton from "./LikeButton.jsx";
import NewButton from "./NewButton.jsx";
import _ from 'lodash';
import AccountPhoto from "./AccountPhoto.jsx";

class NewFeed extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: this.props.data, slider_items: this.props.slider_items };
    console.log(this.props.slider_items);
  }

  render(){
  	return _.map(this.props.data, accountItem => <AccountPhoto key = {accountItem.id} data = {accountItem} slider_items={this.state.slider_items[accountItem.id]} />);
  }
}

export default NewFeed